// ============================================================
// 🔐 PortalAuthContext — état d'auth du Portail Client (Phase 18)
// Distinct de AuthContext (admin/Google). Source de vérité : /api/portal/me.
// Cookie httpOnly => rien à stocker côté JS.
// ============================================================
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { portalApi } from "../services/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [client, setClient] = useState(null);   // { email, has_notary_access, ... } ou null
  const [loading, setLoading] = useState(true);  // true pendant le check initial

  const refresh = useCallback(async () => {
    const { ok, data } = await portalApi("/api/portal/me");
    setClient(ok ? data : null);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const res = await portalApi("/api/portal/login", { method: "POST", body: { email, password } });
    if (res.ok) await refresh();
    return res;
  }, [refresh]);

  // register renvoie la clé API EN CLAIR (une seule fois) -> la page l'affiche.
  const register = useCallback(async (email, password) => {
    const res = await portalApi("/api/portal/register", { method: "POST", body: { email, password } });
    if (res.ok) await refresh();
    return res;
  }, [refresh]);

  const logout = useCallback(async () => {
    await portalApi("/api/portal/logout", { method: "POST" });
    setClient(null);
  }, []);

  return (
    <PortalAuthContext.Provider
      value={{ client, loading, authenticated: !!client, refresh, login, register, logout }}
    >
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used within <PortalAuthProvider>");
  return ctx;
}
